import IconHeadset from '@apollo/icons/default/IconHeadset.svg';
import IconLock from '@apollo/icons/default/IconLock.svg';
import IconMetrics from '@apollo/icons/default/IconMetrics.svg';
import IconOverflowSolid from '@apollo/icons/default/IconOverflowSolid.svg';
import IconPlanet4 from '@apollo/icons/default/IconPlanet4.svg';
import IconSupport from '@apollo/icons/default/IconSupport.svg';
import {
  IconButton,
  Menu,
  MenuButton,
  MenuContent,
  MenuItem,
  MenuList,
} from '@apollo/orbit';
import React from 'react';
import { Link } from 'react-router-dom';

import { useGetContactSupportOverlayLocation } from 'src/components/ContactSupportCTAs';
import { ampli } from 'src/lib/analytics/amplitude/vendor';

export const HelpAndSupportMenuListItems = () => {
  const contactSupportOverlayLocation = useGetContactSupportOverlayLocation();
  return (
    <>
      <MenuItem
        icon={<IconSupport />}
        as="a"
        href="https://support.apollographql.com/"
        rel="noopener noreferrer"
        target="_blank"
      >
        Help Center
      </MenuItem>
      <MenuItem
        as={Link}
        icon={<IconHeadset />}
        to={contactSupportOverlayLocation}
      >
        Contact Support
      </MenuItem>
      <MenuItem
        as="a"
        href="https://www.apollographql.com/trust/"
        rel="noopener noreferrer"
        target="_blank"
        icon={<IconLock />}
      >
        Apollo Trust and Security
      </MenuItem>
      <MenuItem
        as="a"
        href="https://community.apollographql.com"
        rel="noopener noreferrer"
        target="_blank"
        icon={<IconPlanet4 />}
      >
        Community Forum
      </MenuItem>
      <MenuItem
        icon={<IconMetrics />}
        as="a"
        href="https://status.apollographql.com"
        rel="noopener noreferrer"
        target="_blank"
      >
        Status
      </MenuItem>
    </>
  );
};

export const HelpAndSupportMenu = () => (
  <Menu isLazy>
    <MenuButton
      as={IconButton}
      variant="hidden"
      size="sm"
      onClick={() => {
        ampli.helpAndSupportClicked();
      }}
      aria-label="Help and support menu toggle"
    >
      <IconOverflowSolid className="rotate-90" />
    </MenuButton>
    <MenuContent>
      <MenuList>
        <HelpAndSupportMenuListItems />
      </MenuList>
    </MenuContent>
  </Menu>
);
